import { useShouldShowMaintenanceBanner } from '@ui/components/Layout/hooks/useShouldShowMaintenanceBanner';
import { ReactNode } from 'react';
import { Box, Flex } from 'styled-system/jsx';

export const Layout = ({ children }: { children: ReactNode }) => {
  const shouldShowMaintenanceBanner = useShouldShowMaintenanceBanner();

  return (
    <Flex
      bgColor="black.background"
      flexDir="column"
      minHeight="100vh"
      pt={{
        base: 0,
        desktop: shouldShowMaintenanceBanner
          ? 'layout.topNavBarWithAnnouncementHeight'
          : 'layout.topNavBarHeight',
      }}
    >
      <Box flex={1}>{children}</Box>
      <BottomNavContainer />
    </Flex>
  );
};

const BottomNavContainer = () => {
  return (
    <Box
      display={{
        desktop: 'none',
      }}
      // occupy a height prevent bottom nav blocking content in some awkward device height
      h="layout.bottomNavHeight"
    />
  );
};
